<template>
  <!-- <div class="body"> -->
    <div>
      <button class="p-button p-component p-button-help exportBtn" type="button" @click.prevent="exportCSV()">
        <span class="pi pi-upload p-button-icon p-button-icon-left"></span><span class="p-button-label">Export</span>
        <span class="p-ink"></span>
      </button>

      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-col-12">
          <DataTable ref="po"
            :value="bankDetailLists"
            :paginator="true"
            :rows="10" :filters="filters"
            class="p-datatable-responsive p-datatable-gridlines"
          >
          <Column header="S.n">
            <template #body="slotProps">
            {{slotProps.index+1}}
            </template>
          </Column>
          <Column headerStyle="width: 15em"
            header="Name"
            field="name" :sortable="true"
            filterMatchMode="contains"
          >
        <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['name']" />
        </template>
      </Column>
      <Column :sortable="true"
        header="Account No"
        field="accountNumber"
        filterMatchMode="contains"
      >
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['accountNumber']" />
        </template>
      </Column>
      <Column :sortable="true"
        header="Branch"
        field="branch"
        filterMatchMode="contains"
      >
      <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['branch']" />
        </template>
      </Column>
      <Column :sortable="true" header="Account Type" field="type"  filterMatchMode="contains" >
        <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['type']" />
        </template>
      </Column>
      <!-- <Column
        header="Open Date"
        field="openingDate"
        filterMatchMode="contains"
      >
 <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['openingDate']" />
        </template>
      </Column> -->
      <!-- <Column header="Contact Detail" field="accountHeadName" filterField="accountHeadName" filterMatchMode="contains"/>
      <Column header="Address" field="accountHeadName" filterField="accountHeadName" filterMatchMode="contains"/>-->
      <Column :sortable="true"
        header="Opn Balance"
        field="openingBalance"
        filterMatchMode="contains"
        bodyStyle="text-align: right"
      >
      <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['openingBalance']" />
        </template>
      </Column>
      <Column :sortable="true"
        header="Dr-Cr"
        field="openingDrCr"
        filterMatchMode="contains"
      >
      <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['openingDrCr']" />
        </template>
      </Column>
      <Column :sortable="true"
        header="Status"
        field="status"
        filterMatchMode="contains"
      >
      <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['status']" />
        </template>
      </Column>
      <Column header="Action"  >
        <template #body="slotProps">


            <Button icon="pi pi-pencil" class="p-button-raised p-button-success" @click="editBank(slotProps.data)" />

            <Button icon="pi pi-trash" class="p-button-danger p-button-sm"   @click="openDialog(slotProps.data.id)"/>

        </template>
      </Column>
    </DataTable>
     <!-- </div> -->
        </div>
            </div>
    <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteBankDetails"/>
  </div>
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from '../../layout/dialog'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'

export default {
  name: 'bankDetailList',
  data () {
    return {
      dialogShow: false,
      accountId: '',
      loading: false,
      columnList: '',
      filters: {}
    }
  },
  components: {
    DataTable,
    Column,
    Dialog,
    InputText,
    Button
  },
  computed: {
    bankDetailLists() {
      return this.$store.state.accountHead.bankDetailLists
    }
  },
  mounted() {
    this.bankDetailList()
    this.columnNames()
  },
  methods: {
    async bankDetailList() {
      await this.$store.dispatch('loadBankDetailList')
    },
    async deleteBankDetails(value) {
      if (value.trim() === '') {
        let message = {
          message: 'Delete Reason cannot be empty.',
          messageType: 'error'
        }
        this.$emit('delete-message', message)
        this.dialogShow = true
        return
      }
      let deleteRe = {
        bankDetailId: this.accountId,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deleteBankDetail', deleteRe)
      if (resp.data.status === 'SUCCESS') {
        let message = {
          message: resp.data.message,
          messageType: 'success'
        }
        this.$emit('delete-message', message)
      } else {
        let message = {
          message: resp.data.message,
          messageType: 'warn'
        }
        this.$emit('delete-message', message)
      }
      this.closeDialog()
    },
    cancel(data) {
      this.dialogShow = false
    },
    exportCSV() {
      let data = {
        columnList: this.columnList
      }
      axios({
        url: globalKey + '/fileDownload/excelReportAccount/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/Bank List' + '/' + this.$store.getters.fyId + '/' + data.columnList,
        method: 'get',
        headers: { 'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token },
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'bankList.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    columnNames() {
      for (let i = 0; i < this.$refs.po.columns.length; i++) {
        this.columnList += this.$refs.po.columns[i].header + ','
      }
    },
    editBank(data) {
      this.$emit('edit-account', data)
    },
    openDialog(id) {
      this.dialogShow = true
      this.accountId = id
    },
    closeDialog() {
      this.dialogShow = false
      this.deleteReason = ''
    }
  }
}
</script>

<style>
.p-datatable table {
  border-collapse: collapse;
  width: 100%;
  table-layout: auto;
  column-gap: inherit;
}
._message {
  width: fit-content;
  float: right;
  margin-top: -2%;
  margin-right: 1%;
}
</style>



// WEBPACK FOOTER //
// bankDetailList.vue?3aa716b4